"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PreferencesFormFields;
const form_field_element_1 = __importDefault(require("components/form/form-field-element"));
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
function PreferencesFormFields() {
    return (React.createElement("div", null,
        React.createElement("div", { className: "Panel-row Grid u-padNone" },
            React.createElement("div", { className: "Grid-cell Panel-cell Panel-cell--header u-size6of24" },
                React.createElement("h4", null, "Email Newsletter")),
            React.createElement("div", { className: "Grid-cell Panel-cell u-size18of24" },
                React.createElement(redux_form_1.Field, { name: "receivesNewsletter", component: form_field_element_1.default, type: "checkbox", label: React.createElement("span", null, "Send me occasional TeamSnap communication") }),
                React.createElement("small", { className: "under-checkbox" }, "By submitting this form I understand that I am opting to receive TeamSnap communication on features and promotions via email."))),
        React.createElement("div", { className: "Panel-row Grid u-padNone" },
            React.createElement("div", { className: "Grid-cell Panel-cell Panel-cell--header u-size6of24" },
                React.createElement("h4", null, "TeamSnap Ambassadors")),
            React.createElement("div", { className: "Grid-cell Panel-cell u-size18of24" },
                React.createElement("span", null,
                    "Learn More about becoming a ",
                    React.createElement("b", null, "TeamSnap Ambassador. "),
                    React.createElement("a", { href: "https://www.teamsnap.com/ambassadors", target: "_blank" }, "More Info"))))));
}
